import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { AuthService } from '../services/auth.service';
import { LoggingMessageService } from '../services/logging-message.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService, private logger: LoggingMessageService,  private storageService: StorageService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError(err => {
                    if (err.status === 401) {
                        // auto logout if 401 response returned from api
                        const user = this.authenticationService.getTokenEmail();
                        this.logger.warn('error-interceptor', 'intercept', this.storageService.getSubscription(), this.storageService.getSubscriptionsAvailable(), '401 error - User is unauthorized. Logging user out', err.error);
                        this.authenticationService.logout();
                        this.postWindowMessage();
                    }

                    return throwError(err);
                    }
                ));
    }

    private postWindowMessage() {
        setTimeout(() => {
            window.parent.postMessage('logout:', '*');
        }, 0);
    }
}
